import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss'],
})
export class RegistrationFormComponent implements OnInit {
  registrationForm: FormGroup;
  filteredListOfReg: { data: string }[];
  genderList: any;
  filteredGenderList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  categoryList: any[];
  private dialog:MatDialog;
  filteredCategoryList: any[];
  ListOfMedium: { data: string }[];
  filteredListOfMedium: { data: string }[];
  filteredNationalityList: any;
  nationalityList: any;
  ListOfGrid: any;
  filteredListOfGrid: any;
  EcIdd: any;
  dialogRef: MatDialogRef<any>;
  examList: any;
  show = false;
  ListOfReg;
  subjectList: any;
  filteredSubjectList: [];
  selectedSubjectList;
  submitbutton = true;
  updatebutton = false;
  deletebutton = false;
  Branches = false;
  Table = false;
  collegeList: [];
  filteredCollegeList: any;
  streamList: any;
  filteredStreamList: any;
  emid: any;
  stream: 0;
  ListOfExamSkipReason: any;
  filteredListOfExamSkipReason: any;
  courseClgMapList: any;
  minDate: Date;
  filteredstucourseClgMapListList: any;
  currentdate: Date;
  APIService: string;
  PayStatus: string;
  regCreate = true;
  regUpdate = true;
  regDelete = true;
  userPermission: any;
  utp: any;
  isCollege: boolean = false;
  SessionNo: any;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    public router: Router,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder
  ) {
    this.APIService = environment.serviceUrl;
  }
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchList(this.SessionNo);
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Registration Form' && element.PCreate == false) {
          this.regCreate = false;
        }
        if (element.PageName == 'Registration Form' && element.PUpdate == false) {
          this.regUpdate = false;
        }
        if (element.PageName == 'Registration Form' && element.PDelete == false) {
          this.regDelete = false;
        }
      });
    }
    this.minDate = new Date(1900, 0, 1);
    this.currentdate = new Date();
    this.Table = false;
    window.scroll(0,0)
    // this.fetchSecretData();
    this.fetchListExamSkipReason();
    this.registrationForm = this.fb.group({
      CSExBr: new FormControl(""),
      EmSrNoF:new FormControl("1"),
      Code: new FormControl(""),
      Colg: new FormControl(""),
      valid: new FormControl(""),
      changed: new FormControl(""),
      Batch: new FormControl(""),
      Name: new FormControl('',Validators.required),
      RgNo: new FormControl(''),
      FormNo: new FormControl(""),
      CgCode: new FormControl('',Validators.required),
      Chng: new FormControl(""),
      Valid:new FormControl(""),
      Father: new FormControl(""),
      Mother: new FormControl(""),
      BirthDate: new FormControl('',Validators.required),
      Sex: new FormControl('M'),
      Cate: new FormControl('R'),
      Caste: new FormControl(""),
      EMail: new FormControl(""),
      Medium: new FormControl('E'),
      Nation: new FormControl('1'),
      Mobile: new FormControl(""),
      Addr1: new FormControl(""),
      Addr2: new FormControl(""),
      Addr3: new FormControl(""),
      Addr1P: new FormControl(""),
      Addr2P: new FormControl(""),
      Addr3P: new FormControl(""),
      Pin: new FormControl(""),
      PinP: new FormControl(''),
      Place: new FormControl(''),
      StrCode: new FormControl(''),
      PlaceP: new FormControl(''),
      ExSub: new FormControl(''),
      Sub: new FormControl(''),
      EcId: new FormControl('',Validators.required),
      CgCodee: new FormControl(''),
      CoCode: new FormControl(''),
      SnNo: new FormControl(this.SessionNo),
      msg:new FormControl(''),
      EmSkip:new FormControl('')
    });
    let i;
    // this.fetchList(i);
    this.getcollagelist();
    this.getCollegeData(this.userPermission);
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      this.fetchList(this.SessionNo);
      }
    );
  }

  fetchList(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['SnNo'] = SnNo;
    payload['InCode'] = 51;
    payload['OpId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ListOfReg = res.data;
        this.filteredListOfReg = this.ListOfReg.slice();
      } else {
      }
    });
  }

  getcollagelist(){
    this.spinner.show();
    let payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }
  selectedList(e){
    this.spinner.show();
    let payload2 = {};
    payload2['EmCoCode'] = e.CoCode;
    payload2['EmId'] = '';
    this.show = false;
    this.Table = false;
    this.registrationForm.controls['CoCode'].setValue(e.CoCode);
    this.umsService.getExam(payload2).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.examList = res.data[0];
        this.fetchSubjects(this.examList)
      }else{
        this.examList = [];
      }
    });
    this.getCourse(e.CoCode);
    this.getCourseData(e.CoCode)
  }


  getCourse(e){
    this.spinner.show();
    let payload = {};
    payload['CoCode'] = e;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe((res) => {
      this.spinner.hide();
      if(res.data.length > 0){
        this.Branches = true;
      }
      else{
        this.Branches = false;
      }
      if (res.status) {
        this.streamList = res.data;
        this.filteredStreamList = this.streamList.slice();
       
        
      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getSub(e,code){
    this.stream = e
    this.fetchSubjectStr(e,this.examList['EmId']);
  }

  fetchSubjectStr(Strid,EmID) {
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmID;
    payload['EsStrId'] = Strid;
    this.subjectList = [];    
    this.umsService.listofSubjects(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        let x = [];
        this.subjectList = res.data;
        this.filteredSubjectList = this.subjectList.slice();
        this.subjectList.forEach(element => {
        x.push(element.EsCode);
        });
      
        this.registrationForm.controls['Sub'].setValue(x);
      } else {
        this.subjectList = [];
        this.filteredSubjectList = this.subjectList.slice();
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }


  fetchListForGridAndLoad(){
    this.submitbutton = true;
    this.updatebutton = false;
    this.deletebutton = false;
    let tempEcId = this.registrationForm.value['EcId']
    if(this.registrationForm.controls['EcId'].valid){
      this.fetchListForGrid();
      this.registrationForm = this.fb.group({
        CSExBr: new FormControl(''),
        EmSrNoF:new FormControl("1"),
        Code: new FormControl(''),
        Colg: new FormControl(''),
        valid: new FormControl(''),
        changed: new FormControl(''),
        Batch: new FormControl(''),
        Name: new FormControl('',Validators.required),
        RgNo: new FormControl(''),
        FormNo: new FormControl(''),
        CgCode: new FormControl('',Validators.required),
        // Chng: new FormControl(''),
        // Valid:new FormControl(''),
        Father: new FormControl(''),
        Mother: new FormControl(''),
        BirthDate: new FormControl('',Validators.required),
        Sex: new FormControl('M'),
        Cate: new FormControl('R'),
        Caste: new FormControl(""),
        EMail: new FormControl(""),
        Medium: new FormControl('E'),
        Nation: new FormControl('1'),
        Mobile: new FormControl(''),
        Addr1: new FormControl(''),
        Addr2: new FormControl(''),
        Addr3: new FormControl(''),
        Addr1P: new FormControl(''),
        Addr2P: new FormControl(''),
        Addr3P: new FormControl(''),
        Pin: new FormControl(''),
        PinP: new FormControl(''),
        Place: new FormControl(''),
        StrCode: new FormControl(''),
        PlaceP: new FormControl(''),
        ExSub: new FormControl(''),
        Sub: new FormControl(''),
        EcId: new FormControl(tempEcId,Validators.required),
        // CgCodee: new FormControl(''),
        CoCode: new FormControl(''),
        SnNo: new FormControl(this.SessionNo),
        msg:new FormControl(''),
        EmSkip:new FormControl('')
      });
      this.show = true;
      this.getcollagelist();
    }else{
      this.registrationForm.get('EcId').markAsTouched();
    }
  }

  fetchListForGrid() {
    this.submitbutton = true;
    this.updatebutton = false;
    this.deletebutton = false;
    this.show = false;
    let payload = {};
    let formvalue = this.registrationForm.value
    if(this.registrationForm.controls['EcId'].valid){
      this.spinner.show();
      payload['EcId'] = formvalue['EcId']
      payload['CgCode'] = formvalue['CgCodee']
      this.umsService.fetchRegiListForGrid(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.Table = true;
          this.ListOfGrid = res.data;
          this.filteredListOfGrid = this.ListOfGrid.slice();
          
          
        }else{
          this.Table = false;
          this.ListOfGrid = [];
          this.filteredListOfGrid = this.ListOfGrid.slice();
        }
      });
      this.fetchGender();
      this.fetchConstiCate();
      this.fetchCast();
      this.fetchListOfMedium();
      this.fetchNationality();
    }else{
      this.registrationForm.get('EcId').markAsTouched();
    }
   
  }


  fetchGender() {
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchConstiCate() {
    const payload = {};
    payload['CdType'] = 'CT';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCast() {
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
        //this.castGene(payload)
      } else {
      }
    });
  }

  fetchListOfMedium() {
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMedium = res.data;
        this.filteredListOfMedium = this.ListOfMedium.slice();
      } else {
      }
    });
  }
  fetchNationality() {
    const payload = {};
    payload['CdType'] = 'NA';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }
  fetchSubjects(e) {
    const payload = {};
    payload['EsEmId'] = e.EmId;
    this.subjectList = [];    
    this.umsService.listofSubjects(payload).subscribe((res) => {
      if (res.status) {
        let x = [];
        this.subjectList = res.data;
        this.filteredSubjectList = this.subjectList.slice();
        this.subjectList.forEach(element => {
        x.push(element.EsCode);
        });
      
        this.registrationForm.controls['Sub'].setValue(x);
      } else {
        this.subjectList = [];
        this.filteredSubjectList = this.subjectList.slice();
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  addRegFormData() {
    if(this.registrationForm.invalid)
    {
      this.registrationForm.get('Name').markAsTouched();
      this.registrationForm.get('CgCode').markAsTouched();
      this.registrationForm.get('BirthDate').markAsTouched();   
    }else{
      this.spinner.show();
      let submitpayload = this.registrationForm.value;
      submitpayload['StrCode'] = parseInt(submitpayload['StrCode']);
      submitpayload['Sub'] = submitpayload['Sub'].toString();
      this.umsService.addRegiForm(submitpayload).subscribe(
        (res) => {

          this.validateAPI(res,submitpayload);
        },
        (ERROR: HttpErrorResponse) => {
          // this.stateList = [];
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    }
  }
  validateAPI(e,submitpayload){
    this.spinner.show();
    let payload = {};
    payload['EcId'] = submitpayload.EcId
    payload['Batch'] = e.message
    payload['Inst'] = this.umsService.secretdata['ClubPartTrans']
    this.umsService.validateRegiForm(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.fetchListForGrid();
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      },
      (ERROR: HttpErrorResponse) => {
        // this.stateList = [];
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }
  editdata(e){
    this.registrationForm = this.fb.group({
      CSExBr: new FormControl(''),  
      Code: new FormControl(''),  
      Colg: new FormControl(''),  
      valid: new FormControl(e.Valid),  
      changed: new FormControl(''),  
      CgCodee: new FormControl(''), 
      Batch: new FormControl(e.Batch),
      Name: new FormControl(e.Name,Validators.required),
      RgNo: new FormControl(e.RgNo),
      FormNo: new FormControl(e.FormNo),
      CgCode: new FormControl(e.CgCode,Validators.required),
      Chng: new FormControl(e.Chng),  
      Valid:new FormControl(''),  
      Father: new FormControl(e.Father),
      Mother: new FormControl(e.Mother),
      BirthDate: new FormControl(new Date(e.BirthDate),Validators.required),
      Sex: new FormControl(e.Sex),
      Cate: new FormControl(e.Cate),
      Caste: new FormControl(e.Caste),
      EMail: new FormControl(e.EMail),  
      Medium: new FormControl(e.Medium),
      Nation: new FormControl(e.Nation),  
      Mobile: new FormControl(e.Mobile),  
      Addr1: new FormControl(e.Addr1),
      Addr2: new FormControl(e.Addr2),
      Addr3: new FormControl(e.Addr3),
      Addr1P: new FormControl(e.Addr1P),
      Addr2P: new FormControl(e.Addr2P),
      Addr3P: new FormControl(e.Addr3P),
      Pin: new FormControl(e.Pin),
      PinP: new FormControl(e.PinP),
      Place: new FormControl(e.Place),
      StrCode: new FormControl(e.StrCode),
      PlaceP: new FormControl(e.PlaceP),
      ExSub: new FormControl(e.ExSub), 
      Sub: new FormControl(e.Sub.split(",")), 
      EcId: new FormControl(e.EcId,Validators.required), 
      CoCode: new FormControl(e.CoCode),
      SnNo: new FormControl(e.SnNo),
      EmSrNoF: new FormControl(e.EmSrNoF),
      msg:new FormControl(e.Mesg),
      EmSkip:new FormControl('')
    });
    this.submitbutton = false;
    this.updatebutton = true;
    this.deletebutton = true;
    this.show = true;
  }
  update(){
    if(this.registrationForm.invalid)
    {
      this.registrationForm.get('Name').markAsTouched();
      this.registrationForm.get('CgCode').markAsTouched();
      this.registrationForm.get('BirthDate').markAsTouched();   
    }else{
      this.spinner.show();
      let submitpayload = this.registrationForm.value;
      submitpayload['Sub'] = submitpayload['Sub'].toString();
      this.umsService.updateRegiForm(submitpayload).subscribe(
        (res) => {
          this.validateAPI(res,submitpayload);
        },
        (ERROR: HttpErrorResponse) => {
          // this.stateList = [];
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    }
  }

  delete() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deletedata(this.registrationForm.value);
        this.dialogRef.close();
      }
      else {
        this.dialogRef.close();
      }
    });
  }
  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        CSExBr: id.CSExBr,
        Code: id.Code,
        Colg: id.Colg,
        valid: id.valid,
        changed: id.changed,
        CgCodee: id.CgCodee,
        Batch: id.Batch,
        Name: id.Name,
        RgNo: id.RgNo,
        FormNo: id.FormNo,
        CgCode: id.CgCode,
        Chng: id.Chng,
        Valid: id.Valid,
        Father: id.Father,
        Mother: id.Mother,
        BirthDate: id.BirthDate,
        Sex: id.Sex,
        Cate: id.Cate,
        Caste: id.Caste,
        EMail: id.EMail,
        Medium: id.Medium,
        Nation: id.Nation,
        Mobile: id.Mobile,
        Addr1: id.Addr1,
        Addr2: id.Addr2,
        Addr3: id.Addr3,
        Addr1P: id.Addr1P,
        Addr2P: id.Addr2P,
        Addr3P: id.Addr3P,
        Pin: id.Pin,
        PinP: id.PinP,
        Place: id.Place,
        StrCode: id.StrCode,
        PlaceP: id.PlaceP,
        ExSub: id.ExSub,
        Sub: id.Sub,
        EcId: id.EcId,
        CoCode: id.CoCode,
        SnNo: id.SnNo,
        EmSrNoF: id.EmSrNoF,
        msg: id.msg,
        EmSkip: id.EmSkip,
      },
    };
    this.httpClient
      .delete(this.APIService + '/inputs/RegnForm', options)
      .subscribe((s) => {
        this.spinner.hide();
        const cc = [];
        cc.push(s);
        const data = {};
        data['message'] = cc[0].message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.dialogRef.afterClosed().subscribe((result) => {
          this.dialogRef.close();
          this.registrationForm.reset();
          this.registrationForm.controls['EcId'].setErrors(null);
          this.registrationForm.controls['EcId'].clearValidators();
          this.registrationForm.controls['EcId'].updateValueAndValidity();
          this.fetchListForGrid();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );

      });
  }

  fetchListExamSkipReason() {
    const payload = {};
    payload['CdType'] = 'EMSK';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfExamSkipReason = res.data;
        this.filteredListOfExamSkipReason = this.ListOfExamSkipReason.slice();
      } else {
      }
    });
  }


  getCourseData(id) {
    this.spinner.show()
    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.fetchstucourseClgMap(payload3).subscribe(res => {
      this.courseClgMapList = res.data;
      this.spinner.hide()
      this.filteredstucourseClgMapListList = this.courseClgMapList.slice();
      // this.dataSource = new MatTableDataSource(this.facultyList);
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseClgMapList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
   });

  }


  openDialog(){
    
    const dialogRef = this.dialog.open(RegistrationDialogBoxComponent, {
      width: '1000px',
      // data: { selected: k, key : "New"},
      disableClose: true 
    }); 
    dialogRef.afterClosed().subscribe(result => {
      // Handle dialog close actions or data here
      // this.getFeeTempletData();
    });
  }
  print(){
    let submitpayload = this.registrationForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'Registration-Form';
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 117,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  
  getCollegeData(userPermission: any) {
    this.spinner.show();
    let UserCollege = '';
    this.isCollege = false;
    if(userPermission[0].CgUi == 'C'){
      UserCollege = userPermission[0].CgId;
      this.isCollege = true;
    }
    const payload = { 'CgCode': UserCollege };
    this.umsService.getCollege(payload).subscribe(
      (res) => {
        this.spinner.hide();
        const CgName = res.data;
        if(userPermission[0].CgUi == 'C'){
          this.registrationForm.controls['CgCodee'].setValue(CgName[0].CgName);
          // this.isCollege = true;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        return [];
      }
    );
  }
}
